import {
    LegacyCard,
    FormLayout,
    InlineError,
    Modal,
    TextField,
    Toast,
    LegacyTabs,
    ResourceList,
    ResourceItem,
    Layout,
    EmptyState,
    Text,
} from "@shopify/polaris";
import { useEffect, useState, useCallback } from "react";
import Api from '../../helpers/api';

const stripe = Stripe(window.stripe_key);
const stripeElements = stripe.elements();
const stripeCardElement = stripeElements.create('card');

const CustomerCreditCard = props => {

    if (! props.customer) {
        return null;
    }

    const [loading, setLoading] = useState(false);
    const [CCModalActive, setCCModalActive] = useState(false);
    const [CCDetails, setCCDetails] = useState({
        name: '',
        card_id: props.card ? props.card.id : 0
    });
    const [errors, setErrors] = useState({});
    const [selectedTab, setSelectedTab] = useState(0);
    const [creditCardLoaded, setCreditCardLoaded] = useState(false);

    const handleTabChange = useCallback(
        (selectedTabIndex) => setSelectedTab(selectedTabIndex),
        [],
    );

    const assignStripeElement = () => {
        setTimeout(() => {
            if (document.getElementById('card-element'))
                stripeCardElement.mount('#card-element');
        }, 100)
    }

    useEffect(() => {
        if (selectedTab == 0 && creditCardLoaded)
            assignStripeElement();
    }, [selectedTab])

    const storeNewCard = async (event) => {
        if ( CCDetails.name == '') {
            setErrors({
                ...errors,
                ...{name: 'The Cardholder name is required'}
            });
            setLoading(false);
            return;
        }

        const { paymentMethod, error } = await stripe.createPaymentMethod({
            type: 'card',
            card: stripeCardElement,
            billing_details: {
                name: CCDetails.name
            },
        });

        if (error) {
            // Display error.message in your UI.
            setErrors({credit_card: error.message});
            setLoading(false);
        } else {
            setErrors({});
            let form = {
                id: props.customer.id,
                payment_methods: {
                    'processor': 'stripe',
                    'card': paymentMethod.card.last4,
                    'exp_date': paymentMethod.card.exp_month.toString() + '/' + paymentMethod.card.exp_year.toString().slice(-2),
                    'token': paymentMethod.id,
                    'name': CCDetails.name
                }
            }

            // ✅ Here we should make a backend call to store the payment method
            Api.insertCreditCard(form).then(({ data }) => {
                updateUsingSavedCard(data.data.card);
                setLoading(false);
            }).catch(error => {
                setLoading(false);
            });

            // setToast('success', "Created payment method");
        }
    };

    const updateUsingSavedCard = async (card) => {
        let form = {
            id: props.customer.id,
            card_id: card.id,
            location_id: props.locationId ?? null,
            type: props.type
        }

        if ((props.type == 'location' && props.locationId) || props.type =='customer')
        {
            Api.setCreditCard(form).then(({ data }) => {
                props.onUpdate(data.data);
                setCCModalActive(false);
                setLoading(false);
            }).catch(error => {
                setLoading(false);
            });
        }
        else
        {
            form['card'] = card;
            props.onUpdate(form);
            setCCModalActive(false);
            setLoading(false);
        }
    };

    const unhookCard = async () => {
        const form = {
            id: props.customer.id,
            card_id: props.card.id,
            location_id: props.locationId ?? null,
        };
        setLoading(true);

        Api.unhookCreditCard(form).then(({ data }) => {
            props.onUpdate(data.data);
            setCCModalActive(false);
            setLoading(false);
        }).catch(error => {
            setLoading(false);
        });
    }

    const storeCard = async (event) => {
        setLoading(true);

        if (selectedTab == 0)
            await storeNewCard(event);

        if (selectedTab == 1)
            await updateUsingSavedCard(event);

        setSelectedTab(0);
    }

    const deleteCard = async (id) => {
        setLoading(true);
        Api.deleteCreditCard(props.customer.id, id, props.locationId).then(({ data }) => {
            props.onUpdate(data.data);
            setLoading(false);

            if (!items || !items.length)
                setSelectedTab(0);
        });
    }

    const [toastActive, setToastActive] = useState(null);

    const getCardActions = () => {
        let actions = {};

        // We replaced this by a charge to the draft order.
        // if ( props.customer.additional_data.payment_methods != null ) {
        //     actions.primaryFooterAction = {content: 'Charge Credit Card', onAction: () => {alert('To be implemented') }};
        // }

        return actions;
    }

    const setToast = (type, message) => {
        setToastActive({
            type, message
        });
    }

    const toastMarkup = toastActive ? (
        <Toast error={toastActive.type == 'error'} content={toastActive.message} onDismiss={setToastActive(null)} duration={3000} />
    ) : null;

    const CardsEmptyState = () => {
        return (<EmptyState heading="The customer has no saved credit cards"></EmptyState>)
    }

    return (
        <LegacyCard sectioned title="Credit Card" actions={[
            {
                content: props.card ? 'Update Credit Card' : 'Add Credit Card',
                onAction: () => { setCCModalActive(true) }
            },
            props.card && props.locationId  ? {
                content: 'Unhook credit card',
                onAction: unhookCard
            } : {}
        ]} {...getCardActions()}>
            { props.card ? (
                <>
                <p>Credit Card ending in <strong>{ props.card.additional_data.card }</strong></p>
                <p>Expiration Date: <strong>{ props.card.additional_data.exp_date }</strong></p>
                </>
                ) : (
                <p>There is no credit card on file.</p>
            )}

            <Modal
                open={CCModalActive}
                onClose={() => {
                    setCCModalActive(false);
                    setSelectedTab(0);
                }}
                title="Add New Credit Card"
                onTransitionEnd={() => {
                    assignStripeElement();
                    setCreditCardLoaded(true);
                }}
                primaryAction={selectedTab == 0 ? [
                    {
                        content: 'Save Card',
                        id: "card-button",
                        onAction: storeCard,
                        loading: loading
                    }
                ] : []}
            >
                { props.customer && props.customer.cards && props.customer.cards.length > 0 ? (<LegacyTabs tabs={[
                    {
                        id: 'create-new-1',
                        content: 'Add new',
                        accessibilityLabel: 'New',
                        panelID: 'all-customers-content-1',
                    },
                    {
                        id: 'select-existing-1',
                        content: 'Existing (' + (props.customer.cards ? props.customer.cards.length : 0) + ')',
                        panelID: 'accepts-marketing-content-1',
                    },
                ]} selected={selectedTab} onSelect={handleTabChange} />) : ''}

                <Modal.Section>
                    { selectedTab == 0 ? (<FormLayout>
                        <TextField
                            error={errors.name}
                            autoComplete={'off'}
                            id="cardholder-name"
                            value={CCDetails.name}
                            onChange={value => {
                                setCCDetails({
                                    ...CCDetails,
                                    ...{ name: value }
                                })
                            }}
                            label="Cardholder Name"
                            type="text" />

                        <div>
                            <div className="">
                                <div className="Polaris-Labelled__LabelWrapper">
                                    <div className="Polaris-Label">
                                        <label className="Polaris-Label__Text">Credit Card</label>
                                    </div>
                                </div>
                                <div className="Polaris-Connected">
                                    <div className="Polaris-Connected__Item Polaris-Connected__Item--primary">
                                        <div className="Polaris-TextField">
                                            <div className="Polaris-TextField__Input" style={{
                                                border: "1px solid #c1c1c1",
                                                borderRadius: "4px",
                                                paddingTop: '10px',
                                                boxShadow: '0 1px 1px inset rgba(0,0,0,0.1)'
                                            }} id="card-element"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {errors.credit_card != null && <InlineError message={errors.credit_card} fieldID="myFieldID" />}
                    </FormLayout>) : ''}


                    { selectedTab == 1 ? (
                        <Layout.Section>
                            <ResourceList
                                resourceName={{singular: 'Card', plural: 'Cards'}}
                                items={props.customer.cards}
                                emptyState={<CardsEmptyState />}
                                renderItem={(card) => {
                                    const shortcutActions = [
                                        {
                                            content: 'Apply Card',
                                            accessibilityLabel: `Apply Card ${card.id}`,
                                            onAction: (event) => {
                                                setCCDetails({
                                                    ...CCDetails,
                                                    ...{ card_id: card.id }
                                                })
                                                storeCard(card);
                                            }
                                        },
                                        {
                                            content: 'Delete Card',
                                            accessibilityLabel: `Delete card ${card.id}`,
                                            onAction: () => { deleteCard(card.id); }
                                        }
                                    ]
                                    return (
                                        <ResourceItem
                                            id={card.id}
                                            shortcutActions={shortcutActions}
                                        >
                                            <div>
                                                <h3><Text  variant="bodyMd" as="span" fontWeight="semibold">{card.card_holder_name}<br /></Text></h3>
                                                Credit Card ending in <Text  variant="bodyMd" as="span" fontWeight="semibold">{card.additional_data.card}<br /></Text>
                                                Expiration Date: <Text  variant="bodyMd" as="span" fontWeight="semibold">{card.additional_data.exp_date}<br /></Text>
                                            </div>
                                        </ResourceItem>
                                    );
                                }}
                            />
                        </Layout.Section>
                    ) : ''}
                </Modal.Section>
            </Modal>
            {toastMarkup}
        </LegacyCard>
    );
}

export default CustomerCreditCard;
